interface NotificationBadgeProps {
    count: number;
}
const NotificationBadge = (props: NotificationBadgeProps) => {
    const { count } = props;

    return (
        <div className="text-[10px] bg-warning w-5 h-5 ml-[0.25rem] -mt-[0.8rem] rounded-full grid place-items-center text-warning-contrast font-semibold">
            {count}
        </div>
    );
};

export default NotificationBadge;
